// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__bW4Jj","itemA":"Write_itemA__1pfc_","itemB":"Write_itemB__1ZZVL","itemC":"Write_itemC__K_ULG","itemD":"Write_itemD__1d2Am"};